export default {
  UPDATE_STATE: Symbol('UPDATE_STATE'),
  UPDATE_SEARCH_PARAM: Symbol('UPDATE_SEARCH_PARAM'),
  UPDATE_SEARCH_RES: Symbol('UPDATE_SEARCH_RES'),
  UPDATE_RECORD_LIST: Symbol('UPDATE_RECORD_LIST'),
  UPDATE_USAGE_RECORD_HISTORY: Symbol('UPDATE_USAGE_RECORD_HISTORY'),
  UPDATE_ID_CARD_LIST: Symbol('UPDATE_ID_CARD_LIST'),
};
